import { Dispatch, SetStateAction } from "react";

export const advanceStep = (setStep: Dispatch<SetStateAction<number>>) =>
  setStep((currentStep) => currentStep + 1);

export const recedeStep = (setStep: Dispatch<SetStateAction<number>>) =>
  setStep((currentStep) => currentStep - 1);
